
export const  phone = (rule, value, callback) => {
    let regFormat = /^[1][3456789][0-9]{9}$/; //正确手机号
    if (!value) {
        return callback(new Error('请输入手机号'));
    }
    if (!(regFormat.test(value))) {
        callback(new Error('请输入正确手机号'));
    } else {
        callback();
    }
};
export const email = (rule, value, callback) => {
    let regFormat = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/; //正确手机号
    if (!value) {
        return callback();
    }
    if (!(regFormat.test(value))) {
        callback(new Error('请输入正确的邮箱'));
    } else {
        callback();
    }
};

export const validatepassold = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入之前的密码'));
    }
    callback();
};
export const validatePass = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入密码'));
    }
    sessionStorage.setItem("password", value);
    callback();
};
export const validatePass2 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请再次输入密码'));
    } else if (value !==  sessionStorage.getItem("password")) {
        callback(new Error('两次输入密码不一致!'));
    } else {
        callback();
    }
};
